// Mock data for Eau Gratuite

export const mockData = {
  hero: {
    title: "Votre publicité sur des bouteilles d'eau gratuites.",
    subtitle: "Promouvez votre marque tout en finançant des puits d'eau avec l'Association Ulker's.",
    ctaButtons: [
      { text: "Promouvoir votre marque", type: "primary" },
      { text: "Devenir annonceur", type: "secondary" }
    ],
    heroImage: "https://images.unsplash.com/photo-1574482620811-1aa16ffe3c82?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxjbGVhbiUyMHdhdGVyfGVufDB8fHx8MTc1NzY3NzAyOHww&ixlib=rb-4.1.0&q=85"
  },

  howItWorks: {
    title: "Comment ça marche ?",
    subtitle: "Un modèle publicitaire innovant et solidaire en 3 étapes",
    steps: [
      {
        id: 1,
        title: "Vous financez votre campagne",
        description: "Votre entreprise investit dans une campagne publicitaire sur nos bouteilles d'eau.",
        icon: "building"
      },
      {
        id: 2,
        title: "Distribution gratuite en Île-de-France",
        description: "Vos bouteilles publicitaires avec QR code sont distribuées gratuitement au grand public francilien.",
        icon: "droplets"
      },
      {
        id: 3,
        title: "Impact social garanti",
        description: "Une partie de votre investissement finance des puits d'eau via l'Association Ulker's.",
        icon: "heart"
      }
    ]
  },

  mission: {
    title: "Mission & Impact",
    subtitle: "Une plateforme publicitaire innovante qui génère un impact social positif",
    mainText: "Notre mission est de transformer vos investissements publicitaires en impact social concret : vos campagnes sur nos bouteilles d'eau gratuites financent la construction de puits d'eau durables dans les régions qui en ont le plus besoin.",
    partnership: {
      title: "Partenariat officiel avec l'Association Ulker's",
      description: "Chaque campagne publicitaire contribue directement au financement de puits d'eau durable.",
      impact: "1 million de bouteilles publicitaires distribuées = 50 puits construits avec Ulker's"
    },
    images: [
      "https://images.unsplash.com/photo-1668961915523-884872e392f8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwzfHx3YXRlciUyMHdlbGwlMjBhZnJpY2F8ZW58MHx8fHwxNzU3Njc3MDY1fDA&ixlib=rb-4.1.0&q=85",
      "https://images.pexels.com/photos/28101461/pexels-photo-28101461.jpeg"
    ],
    testimonials: [
      {
        text: "Grâce à Eau Gratuite, notre village a maintenant accès à l'eau potable 24h/24.",
        author: "Amina, Burkina Faso",
        avatar: "https://images.unsplash.com/photo-1655720359248-eeace8c709c5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxzb2xpZGFyaXR5fGVufDB8fHx8MTc1NzY3NzAzOHww&ixlib=rb-4.1.0&q=85"
      }
    ]
  },

  partners: {
    title: "Annonceurs & Marques",
    subtitle: "Une campagne publicitaire qui génère un impact social positif",
    benefits: [
      "Visibilité massive avec distribution gratuite au public",
      "QR code personnalisé pour rediriger vers votre site web",
      "Impact RSE mesurable et transparent",
      "Communication positive autour de votre engagement social",
      "Rapports détaillés sur les scans QR et impact social"
    ],
    partnerLogos: [
      { name: "Partenaire 1", logo: "https://via.placeholder.com/150x80/22C55E/FFFFFF?text=ECO+BRAND" },
      { name: "Partenaire 2", logo: "https://via.placeholder.com/150x80/0EA5E9/FFFFFF?text=WATER+CO" },
      { name: "Partenaire 3", logo: "https://via.placeholder.com/150x80/10B981/FFFFFF?text=GREEN+TECH" }
    ]
  },

  faq: {
    title: "Questions Fréquentes",
    questions: [
      {
        question: "Comment fonctionne votre modèle publicitaire ?",
        answer: "Votre marque apparaît sur nos bouteilles d'eau qui sont distribuées gratuitement au grand public en Île-de-France, garantissant une visibilité massive et un impact social positif.",
        category: "partenariats"
      },
      {
        question: "Quel est le coût d'une campagne publicitaire ?",
        answer: "Nos tarifs dépendent du volume de bouteilles et de la durée de campagne. Contactez-nous pour un devis personnalisé adapté à vos objectifs.",
        category: "partenariats"
      },
      {
        question: "Où sont distribuées les bouteilles ?",
        answer: "Nos bouteilles sont distribuées exclusivement en Île-de-France via des points stratégiques : universités, centres commerciaux, événements, entreprises.",
        category: "distribution"
      },
      {
        question: "Comment obtenir mon eau gratuite ?",
        answer: "Les bouteilles sont distribuées gratuitement dans les lieux publics franciliens. Suivez-nous sur les réseaux sociaux pour connaître les points de distribution.",
        category: "distribution"
      },
      {
        question: "Combien de bouteilles sont distribuées par jour ?",
        answer: "Nous distribuons environ 50 000 bouteilles par jour en Île-de-France, touchant une audience diversifiée et engagée.",
        category: "distribution"
      },
      {
        question: "Comment l'Association Ulker's utilise-t-elle les fonds ?",
        answer: "Une partie de votre investissement publicitaire finance directement la construction et la maintenance de puits d'eau potable dans les régions qui en ont besoin.",
        category: "impact"
      },
      {
        question: "Quel est l'impact social réel ?",
        answer: "Chaque campagne contribue à construire des puits d'eau. Nous avons déjà financé plus de 50 puits grâce aux revenus publicitaires.",
        category: "impact"
      },
      {
        question: "Comment suivre l'impact de ma contribution ?",
        answer: "Vous recevez des rapports détaillés avec photos et géolocalisation des puits construits grâce à votre campagne.",
        category: "impact"
      },
      {
        question: "Vos bouteilles sont-elles écologiques ?",
        answer: "Nos bouteilles sont 100% recyclables et nous compensons notre empreinte carbone par la construction de puits d'eau.",
        category: "ecologie"
      },
      {
        question: "Comment réduisez-vous l'impact environnemental ?",
        answer: "Distribution locale en Île-de-France, bouteilles recyclables, partenariat avec des entreprises de recyclage, et compensation carbone via les puits d'eau.",
        category: "ecologie"
      },
      {
        question: "Comment mesurer l'impact de ma campagne ?",
        answer: "Vous recevez des rapports détaillés sur la distribution, l'audience touchée et l'impact social généré par votre campagne.",
        category: "compte"
      },
      {
        question: "Puis-je modifier ma campagne en cours ?",
        answer: "Les campagnes ne peuvent pas être modifiées une fois lancées. Contactez-nous pour planifier votre prochaine campagne avec les ajustements souhaités.",
        category: "compte"
      }
    ]
  },

  contact: {
    title: "Lancez votre campagne publicitaire solidaire",
    subtitle: "Une question ? Prêt à promouvoir votre marque ? Contactez-nous !",
    email: "contact@eaugratuite.io",
    phone: "07 49 97 72 32",
    socialLinks: [
      { platform: "Facebook", url: "#", icon: "facebook" },
      { platform: "Twitter", url: "#", icon: "twitter" },
      { platform: "Instagram", url: "https://www.instagram.com/eaugratuite.io/", icon: "instagram" },
      { platform: "LinkedIn", url: "#", icon: "linkedin" }
    ]
  },

  navigation: [
    { name: "Accueil", path: "/" },
    { name: "Comment ça marche", path: "/comment-ca-marche" },
    { name: "Mission & Impact", path: "/mission-impact" },
    { name: "Partenaires", path: "/partenaires" },
    { name: "Tarifs", path: "/tarifs" },
    { name: "FAQ", path: "/faq" },
    { name: "Contact", path: "/contact" }
  ]
};

export default mockData;